import { render, staticRenderFns } from "./contents_report.vue?vue&type=template&id=1fa4fc3b&"
import script from "./contents_report.vue?vue&type=script&lang=js&"
export * from "./contents_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports